<script lang="ts">
  import ButtonLink from '@athena-lib/Button/ButtonLink/ButtonLink.svelte';
  import { getCommonTranslations } from '@athena-lib/commonTranslationsContext';
  import QuoteCard, { type QuoteCardProps } from '@athena-lib/QuoteCard/QuoteCard.svelte';
  import { Text, HeadingMedium } from '@athena-lib/Text';
  import {
    CustomStickersBundle,
    type CustomStickersBundleProps,
  } from '@athena-lib/CustomStickersBundle';
  import { ShoppingCart } from '@athena-lib/Icons';
  import Spinner from '@athena-lib/Icons/Spinner.svelte';

  export type ClickAction = 'review_cart' | 'checkout_now';

  const {
    quoteCards,
    customStickersBundle,
    checkoutUrl,
    onActionClicked,
    reviewCartUrl,
    expressCheckoutElementId,
    onItemClick,
    isManualOrder,
  }: {
    customStickersBundle?: CustomStickersBundleProps;
    quoteCards: Array<QuoteCardProps>;
    checkoutUrl: string;
    reviewCartUrl: string;
    onActionClicked?: (action: ClickAction) => void;
    expressCheckoutElementId?: string;
    onItemClick?: (id: string) => void;
    isManualOrder?: boolean;
  } = $props();
  const translations = getCommonTranslations();

  function onClick() {
    if (onActionClicked) {
      onActionClicked('checkout_now');
    }
  }
</script>

<div class="flex h-full flex-col justify-between p-4 px-4 pt-[28px] lg:px-8">
  <div class="flex flex-col justify-center">
    <div class="mb-[28px] flex flex-row items-center gap-4">
      <ShoppingCart sizeClass="h-8 w-8" />
      <HeadingMedium class="font-bold" size="small">{translations.addedToCart}</HeadingMedium>
    </div>
    <div class="flex h-[190px] flex-col gap-2">
      {#if quoteCards.length === 0}
        <Spinner sizeClass="h-12 w-12" />
      {:else if quoteCards.length > 0}
        <QuoteCard
          {onItemClick}
          cartType="mini"
          {isManualOrder}
          {...quoteCards[quoteCards.length - 1]}
        />
      {/if}
    </div>
    {#if customStickersBundle}
      <CustomStickersBundle {...customStickersBundle} />
    {/if}

    {#if expressCheckoutElementId}
      <div class="flex flex-row justify-center">
        <Text color="medium" size="xsmall">{translations.expressCheckout}</Text>
      </div>
      <div id={expressCheckoutElementId}></div>
    {/if}
  </div>
  <div class="flex flex-col items-center">
    <a
      href={reviewCartUrl}
      color="dark"
      class="flex h-[4.5rem] w-full basis-auto items-center justify-center underline"
      onclick={() => {
        if (onActionClicked) {
          onActionClicked('review_cart');
        }
      }}
    >
      {translations.reviewCart} ({quoteCards.length})
    </a>
    <ButtonLink class="w-full basis-auto" link={{ href: checkoutUrl }} {onClick}>
      {translations.checkoutNow}
    </ButtonLink>
  </div>
</div>
